import React, { useState } from 'react'
import WarehouseStockInfoForm from './WarehouseStockInfoForm';
import WarehouseStockInfoList from './WarehouseStockInfoList';

const WarehouseStockInfo= () => {
    const [fromIsShown, setFromIsShown] = useState(false);
    const [upData, setUpData] = useState(false);
    const [serviceId, setServiceId] = useState("none");

  return (
    <>
      {fromIsShown ? (
          <WarehouseStockInfoForm addForm={setFromIsShown} update={upData} sId={serviceId}/>
        ) : (
          <WarehouseStockInfoList addForm={setFromIsShown} update={setUpData} sId={setServiceId}/>
        )}
  
    </>
  )
}

export default WarehouseStockInfo;